import { createSlice } from "@reduxjs/toolkit";
import { Bounce, toast } from "react-toastify";

const initialState = {
  connected: false,
  isServerOffline: false,
};

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    socketConnected: (state) => {
      state.connected = true;
      state.isServerOffline = false;
    },
    socketDisconnected: (state) => {
      state.connected = false;
    },
    setServerOffline: (state, action) => {
      state.isServerOffline = action.payload;
    },
    socketReceiveMessage: (state, action) => {
    
      toast[action.payload[1]](action.payload[0],{
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    },
    // socketTimerSync: (state, action) => {
    //   // Синхронизация таймера между клиентами
    // },
  },
});

export const { socketConnected, socketDisconnected, socketReceiveMessage, setServerOffline } = socketSlice.actions;
// export const { socketConnected, socketDisconnected, socketReceiveMessage, setServerOffline, socketTimerSync } = socketSlice.actions;

export default socketSlice.reducer;